import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared';
import { contactLinkerWithPhoneNumberQuerySchema } from '@/_pages/contacts/shared/schemas';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';
import { companyLinkerWithPhoneNumbersQuerySchema } from '@/_schemas/companies/company-query-linker-with-phone-numbers-schema';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { competitorQueryLinkerSchema } from './competitor-query-linker-schema';

export const competitorQuerySchema = z.object({
  ...competitorQueryLinkerSchema.shape,
  business_tagline: z.string().nullable(),
  number_of_customers: z.number().nullable(),
  founded_date: z.string().nullable(),
  headcount: z.number().nullable(),
  email: z.string().nullable(),
  website: z.string().nullable(),
  // creator_id: z.number().nullable(),
  pricing_strategy: z.string().nullable(),
  tidbits: z.string().nullable(),
  weaknesses: z.string().nullable(),
  strengths: z.string().nullable(),
  how_to_win: z.string().nullable(),
  behavior: z.union([z.literal('friendly'), z.null()]).nullable(),
  glassdoor_url: z.string().nullable(),
  associated_clients_count: z.number(),
  current_web_clients_count: z.number().optional(),
  primary_contact_count: z.number().nullable(),
  addresses: z.array(addressQuerySchema).nullish(),
  primary_contact: z.array(contactLinkerWithPhoneNumberQuerySchema).nullish(),
  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
  ceo_contact: z.array(contactLinkerWithPhoneNumberQuerySchema).nullish(),
  associated_clients: z.array(companyQueryLinkerSchema).nullish(),
  current_web_clients: z.array(companyLinkerWithPhoneNumbersQuerySchema).nullish(),
});

export type CompetitorQuerySchema = z.infer<typeof competitorQuerySchema>;

export const competitorsQueryAllSchema = paginatedResponseSchema(competitorQuerySchema);

export type CompetitorsQueryAllSchema = z.infer<typeof competitorsQueryAllSchema>;
